var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 34,
  fill: "none",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M32 128c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v16H32zm0 64h448v192c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48zm64 80v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16"
})));
export { SvgCreditCard as ReactComponent };
export default __webpack_public_path__ + "CreditCard.f2498fe9.svg";